import 'mapbox-gl/dist/mapbox-gl.css';
import { memo, useEffect } from 'react';
import { Map as MapboxMap, MapMouseEvent, useMap, ViewStateChangeEvent } from 'react-map-gl/mapbox';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useDebounceCallback } from 'usehooks-ts';
import { JOBS_PAGE, MIN_HEIGHT_MAP, MIN_WIDTH_MAP, USERS_PAGE } from '../../../constants/app';
import { environment } from '../../../environments/environment';
import { pageState, sidenavIsPinnedState } from '../../../storage/app';
import { mapPaddingState, mapStyleState, mapViewState } from '../../../storage/map';
import { MapOptions } from './MapOptions';
import { MapSearchBox } from './MapSearchBox';
import { TrafficLayer } from './layers/TrafficLayer';
import JobsClusters from './markers/JobsClusters';
import UsersClusters from './markers/UsersClusters';
import './styles/mapbox.css';

type Props = {
  fullWindow?: boolean;
  onlyVeiw?: boolean;
  minHeight?: string;
  id?: string;
};
function Map({ fullWindow = true, minHeight, onlyVeiw = false }: Readonly<Props>) {
  const { map } = useMap();
  const [viewState, setViewState] = useRecoilState(mapViewState);
  const mapStyle = useRecoilValue(mapStyleState);
  const sidenavIsPinned = useRecoilValue(sidenavIsPinnedState);
  const mapPadding = useRecoilValue(mapPaddingState);
  const page = useRecoilValue(pageState);

  // Time needed for side menu animation
  const mapResize = useDebounceCallback(function () {
    map?.resize();
  }, 300);

  useEffect(() => {
    queueMicrotask(() => {
      if (!sidenavIsPinned) {
        mapResize();
        return;
      }
      map?.resize();
    });
  }, [sidenavIsPinned]);

  useEffect(() => {
    queueMicrotask(() => {
      map?.resize();
    });
  }, [map]);

  const onMoveEnd = (ev: ViewStateChangeEvent) => {
    setViewState(ev.viewState);
  };

  const onClick = async (ev: MapMouseEvent) => {
    if (onlyVeiw) return;
    // const point = {
    //   lat: ev.lngLat.lat,
    //   lng: ev.lngLat.lng,
    // };
    // const address = await getAddressFromPoint(point);
  };

  return (
    <MapboxMap
      id="map"
      reuseMaps
      mapboxAccessToken={environment.mapboxAPIKey}
      initialViewState={{ ...viewState }}
      onClick={onClick}
      mapStyle={mapStyle}
      onMoveEnd={onMoveEnd}
      projection={{ name: 'mercator' }}
      padding={{
        left: mapPadding,
        bottom: 0,
        right: 0,
        top: 0,
      }}
      style={{
        position: fullWindow ? 'absolute' : undefined,
        flex: '1',
        minWidth: MIN_WIDTH_MAP,
        minHeight: minHeight ?? MIN_HEIGHT_MAP,
      }}
      scrollZoom={true}
      keyboard={true}
      doubleClickZoom={true}
      dragRotate={false}
      minZoom={0}
      maxZoom={18}
    >
      <TrafficLayer />
      <MapSearchBox />
      <MapOptions />
      {page === USERS_PAGE.id && <UsersClusters />}
      {page === JOBS_PAGE.id && <JobsClusters />}
    </MapboxMap>
  );
}

export default memo(Map);
